import Swiper from "swiper";
import { Navigation, Pagination, Controller, Autoplay, EffectFade, FreeMode } from 'swiper/modules';

// Slider Swiper
const sellingSliderswiper = new Swiper('.swiper#sellingSlider', {
  loop: true,
  modules: [Navigation, Pagination],
  pagination: {
    el: '.swiper-pagination',
    clickable: true
  },
  spaceBetween:40,
});


// Main Swiper
const locationMainSwiper = new Swiper('.slider-main', {
    loop: true,
    autoplay: {
        delay: 3000, // Adjust delay as needed
        disableOnInteraction: false,
    },
    modules: [Navigation, Pagination, Controller, Autoplay,EffectFade ],
    pagination: false,
    spaceBetween: 40,
    effect: 'fade', // Use fade effect for smooth transitions
    fadeEffect: {
        crossFade: true, // Ensures smooth cross-fading
    },
    speed: 800, // Transition duration in milliseconds
    cssMode: false, // Disable cssMode if not needed, or configure easing below
    // If you want to use cssMode with custom easing:
    // cssMode: {
    //     easing: 'ease-in-out'
    // }
});

// Thumbnail Swiper
const locationThumbSwiper = new Swiper('.slider-thumb', {
    modules: [Navigation, Pagination, Controller, EffectFade],
    loop: true,
    pagination: {
        el: '.swiper-pagination-custom',
        type: 'custom',
        clickable: true,
        renderCustom: function (swiper, current, total) {
            const progress = ((current - 1) / (total - 1)) * 100;
            return `
                <div class="custom-pagination">
                    <span class="pagination-counter">${current}</span>
                    <div class="pagination-progress">
                        <div class="progress-bar" style="width: ${progress}%;"></div>
                    </div>
                    <span class="pagination-total">${total}</span>
                </div>
            `;
        }
    },
    spaceBetween: 40,
    allowTouchMove: false,
    // effect: 'fade', // Match the effect with main swiper
    // fadeEffect: {
    //     crossFade: true,
    // },
    speed: 800, // Match the speed with main swiper
});

// Link the swipers
locationMainSwiper.controller.control = locationThumbSwiper;